module.exports = __webpack_public_path__ + "static/pier1_banner-1948762df293264a9ed72e142af7002a.png";